import IconButton from '@material-ui/core/IconButton'
import { ArrowBack } from '@styled-icons/material-rounded/ArrowBack'
import * as S from './index.style'
import { useHistory } from 'react-router-dom'
import theme from 'styles/theme'

export type BackButtonProps = {
  /** Propriedade para indicar o titulo da página atual */
  titulo?: string
  onClick?: () => void
}

/** Componente que consiste em um botao de voltar com um texto ao lado */
const BackButton: React.FC<BackButtonProps> = ({ titulo, onClick }) => {
  const history = useHistory()

  if (!onClick) {
    onClick = () => history.goBack()
  }

  return (
    <S.Wrapper>
      <IconButton component="span" onClick={onClick}>
        <ArrowBack data-cy="iconeArrowBack" size={24} color={theme.colors.gray} />
      </IconButton>
      <S.Title data-cy="labelTitulo">{titulo}</S.Title>
    </S.Wrapper>
  )
}

export default BackButton
